import { Box, HStack, Span } from '@bpba/ui-components';
import React from 'react';
import styled from 'styled-components';

type DesplegableProps = {
  text: string;
  title: string;
};

export const Desplegable = (props: DesplegableProps) => {
  if (props.text === null || props.title === null) return <></>;

  return (
    <Box flexDirection="column">
      <StyledHStack justifyContent="space-between" paddingBottom={2}>
        <Span fontWeight={600} fontSize={'18px'}>
          {props.title}
        </Span>
      </StyledHStack>
      <Box paddingY={2}>
        <div style={HTMLstyle} dangerouslySetInnerHTML={{ __html: props.text }} />
      </Box>
    </Box>
  );
};

const StyledHStack = styled(HStack)({
  cursor: 'pointer',
});

const HTMLstyle = { textAlign: 'justify' as 'justify', FontSize: '18px', lineHeight: '22px', fontWeight: 500 };
